module.exports = {"id":"204234","name":"Edgar Badía","rating":"73","photo":"./data/images/photos/3/204234.png","club":{"name":"CF Reus Deportiu","logo":"./data/images/clubs/CFReusDeportiu.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EdgarBadia0.json
// module id = 1167
// module chunks = 0